export const DeviceType = Object.freeze({
  IGlucoseGlucometer: 1,
  BodyTraceScale: 2,
  BodyTraceBloodPressureCuff: 3,
  BioTelGlucometer: 4,
  TranstekGlucometer: 5,
});
